// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, createUserWithEmailAndPassword, signInWithEmailAndPassword } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";// TODO: Add SDKs for Firebase products that you want to use
import { getFunctions } from "firebase/functions";
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyCzYYYg-VMrtiDM3eGCjF8RWIwD0yI6yrg",
    authDomain: "impotmaxdc-8e490.firebaseapp.com",
    projectId: "impotmaxdc-8e490",
    storageBucket: "impotmaxdc-8e490.firebasestorage.app",
    messagingSenderId: "294178384709",
    appId: "1:294178384709:web:26df689eac51c3e3a92c2c"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);


// Initialize services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);
export { createUserWithEmailAndPassword, signInWithEmailAndPassword };
